"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRResponse = void 0;
const responseResolvers_1 = require("../xhr/responseResolvers");
class XHRResponse {
    static getXHRHeaders(response) {
        const headers = {};
        response.headers.forEach((value, key) => {
            headers[key] = value;
        });
        return headers;
    }
    constructor(data, response, calls, params) {
        this.calls = calls;
        this.reference = response;
        this.data = data;
        this.params = params;
    }
    static create(response, params, calls) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = (yield responseResolvers_1.ResponseResolver.resolve(response, params.responseType));
            const responseParams = {
                data,
                responseHeaders: this.getXHRHeaders(response),
                httpStatus: response.status,
                httpStatusText: response.statusText || '',
                ok: response.ok,
            };
            return new XHRResponse(responseParams, response, calls, {
                responseType: params.responseType,
            });
        });
    }
    getPluginResponseData() {
        return {
            reference: this.reference,
            data: this.data,
            calls: this.calls,
            params: this.params,
        };
    }
}
exports.XHRResponse = XHRResponse;
//# sourceMappingURL=XHRResponse.js.map